import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { ServiceWorkerModule } from '@angular/service-worker';
import { RouterModule } from '@angular/router';
import { AppRoutingModule } from './app-routing.module';
import { FeatureToggleModule, SecurityModule } from '@mynexus/mynexus-ui-lib';
import { CoreModule } from '@core/core.module';
import { ElementRegistryService } from '@core/service/element-registry.service';
import { MsalModule } from '@azure/msal-angular';
import { ButtonModule } from 'primeng/button';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ToastModule } from 'primeng/toast';
import { BulkToastComponent } from '@shared/components/toasts/bulk-toast.component';
import { DefaultModule } from '@feature/default/default.module';
import {
  apiUrlFactory,
  CONFIG_FILE,
  ConfigService,
  FEATURE_MODULE_URL
} from '@core/config/config.service';
import { MainComponent } from '@feature/main/main.component';
import { MfeCoreModule } from '@mynexus/mfe-core';
import { AppComponent } from './app.component';
import { providePrimeNG } from 'primeng/config';
import { Carelon, CSS_LAYERS_ORDER } from '@mynexus/theme';

@NgModule({
  imports: [
    BrowserModule,
    RouterModule,
    AppRoutingModule,
    CoreModule,
    MfeCoreModule,
    MsalModule,
    ButtonModule,
    ConfirmDialogModule,
    ToastModule,
    BulkToastComponent,
    DefaultModule,
    MainComponent,
    FeatureToggleModule.forRoot(FEATURE_MODULE_URL),
    SecurityModule.forRoot([]),
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: false })
  ],
  declarations: [AppComponent],
  providers: [
    ElementRegistryService,
    {
      provide: FEATURE_MODULE_URL,
      useFactory: (...args: [ConfigService, string]) =>
        apiUrlFactory(...args).hhApiUrl.endsWith('/') ? apiUrlFactory(...args).hhApiUrl : `${apiUrlFactory(...args).hhApiUrl}/`,
      deps: [ConfigService, CONFIG_FILE]
    },
    providePrimeNG({
      ripple: false,
      theme: {
        preset: Carelon,
        options: {
          darkModeSelector: false,
          cssLayer: {
            name: 'primeng',
            order: CSS_LAYERS_ORDER
          }
        }
      }
    })
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule {}
